import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DisabilitySurvey } from '@ascschool/model/survey/disability-survey';
import { TeacherSurvey } from '@ascschool/model/survey/teacher-survey';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SurveyPublicService {
  httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
    })
};
  version = 'v1.0';
  url = environment.apiUrl + this.version ;
  constructor(private http: HttpClient) { }

  getById(id: any): Observable<any> {
    return this.http.get(this.url + `/StudentSurveyPublic/GetById/${id}` , this.httpOptions);
  }
  getStaffById(id: any): Observable<any> {
    return this.http.get(this.url + `/StaffSurveyPublic/GetById/${id}` , this.httpOptions);
  }
  //
  getPublicCommunityCoordinations(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicCommunityCoordinations' + '/GetSelectPaging?' + queryString);
  }
  //
  getPublicDisabilityPolicy(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicDisabilityPolicy' + '/GetSelectPaging?' + queryString);
  } 
  //
  getPublicDisCaregivers(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicDisCaregivers' + '/GetSelectPaging?' + queryString);
  } 
  //
  getPublicDistricts(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicDistricts' + '/GetSelectPaging?' + queryString);
  } 
  //
  getPublicWards(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicWards' + '/GetSelectPaging?' + queryString);
  } 
  //
  getPublicTypeOfDisabilitys(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicTypeOfDisabilitys' + '/GetSelectPaging?' + queryString);
  } 
  //
  getPublicLevels(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicLevels' + '/GetSelectPaging?' + queryString);
  } 
  //
  getPublicStatuses(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicStatuses' + '/GetSelectPaging?' + queryString);
  } 
  //
  getPublicNeedOfDisabilities(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicNeedOfDisabilities' + '/GetSelectPaging?' + queryString);
  } 
  //
  getPublicEmploymentStatus(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicEmploymentStatus' + '/GetSelectPaging?' + queryString);
  } 
  //
  getPublicMaritalStatus(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicMaritalStatus' + '/GetSelectPaging?' + queryString);
  }
  // 
  getPublicLivingConditions(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicLivingConditions' + '/GetSelectPaging?' + queryString);
  }
  // 
  getPublicLevelOfDevelopments(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicLevelOfDevelopments' + '/GetSelectPaging?' + queryString);
  }
  // 
  getPublicLevelOfDevelopmentTypes(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicLevelOfDevelopmentTypes' + '/GetSelectPaging?' + queryString);
  }
  // 
  getPublicEducationalSupports(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicEducationalSupports' + '/GetSelectPaging?' + queryString);
  }
  // 
  getPublicModesOfEducations(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicModesOfEducations' + '/GetSelectPaging?' + queryString);
  }
  // 
  getPublicStudyModes(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicStudyModes' + '/GetSelectPaging?' + queryString);
  }//
  getPublicInformationSources(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicInformationSources' + '/GetSelectPaging?' + queryString);
  }//
  getPublicLocalGovernmentCoordinations(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicLocalGovernmentCoordinations' + '/GetSelectPaging?' + queryString);
  }
  // 
  getPublicFolks(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicFolks' + '/GetSelectPaging?' + queryString);
  }
  // 
  getPublicProvinces(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicProvinces' + '/GetSelectPaging?' + queryString);
  } 
  getPublicEducationLevels(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicEducationLevels' + '/GetSelectPaging?' + queryString);
  } 
  getPublicSchoolLevels(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicSchoolLevels' + '/GetSelectPaging?' + queryString);
  } 
  getPublicInterventionStatuss(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicInterventionStatuss' + '/GetSelectPaging?' + queryString);
  }
  // tutor
  getPublicRelationships(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicCaRelationships' + '/GetSelectPaging?' + queryString);
  }
  //Loại kỹ năng
  getPublicSkillTypes(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicCaSkillTypes' + '/GetSelectPaging?' + queryString);
  }
  // Danh muc Đào tạo bồi dưỡng về chăm sóc giáo dục và hỗ trợ - Noi dung)
  getPublicCaTutorTrainingAndRetrainings(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicCaTutorTrainingAndRetrainings' + '/GetSelectPaging?' + queryString);
  }
  // Danh muc Đào tạo bồi dưỡng về chăm sóc giáo dục và hỗ trợ - Loai)
  getPublicCaTutorTrainingAndRetrainingTypes(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicCaTutorTrainingAndRetrainingTypes' + '/GetSelectPaging?' + queryString);
  }   

  AddStudentSurvey(Survey: DisabilitySurvey): Observable<any> {
    if(Survey.id == 0 || Survey.id == undefined) {
        return this.http.post(this.url  + '/StudentSurveyPublic/Add', Survey, this.httpOptions);
    } 
  }
  //////////////////////////////////////////////////////////////////////////////Giáo Viên///////////////////////////////////////////////////////////////////////////////////
  // Danh mục Nội dung điều chỉnh 
  getPublicAdjustContents(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicAdjustContents' + '/GetSelectPaging?' + queryString);
  }  
  // Danh mục Khó khăn trong GD người khuyết tật 
  getPublicDifficultyInEducations(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicDifficultyInEducations' + '/GetSelectPaging?' + queryString);
  }  
  // Danh mục Loai phuong tien, thiet bi, hoc lieu 
  getPublicFacilitiesAndEquipment(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicFacilitiesAndEquipment' + '/GetSelectPaging?' + queryString);
  }   
  // Danh mục Loai phuong tien, thiet bi, hoc lieu 
  getPublicDisFacilitiesAndEquipmentStaffs(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicDisFacilitiesAndEquipmentStaffs' + '/GetSelectPaging?' + queryString);
  }   
  // Danh mục người tham gia
  getPublicParticipants(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicParticipants' + '/GetSelectPaging?' + queryString);
  }  
  // Danh mục Chế độ tham gia giáo dục NKT
  getPublicParticipationMode(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicParticipationMode' + '/GetSelectPaging?' + queryString);
  }  
  // Danh mục Đào tạo/bồi dưỡng về giáo dục người khuyết tật 
  getPublicStaffCertificate(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicStaffCertificate' + '/GetSelectPaging?' + queryString);
  }  
  // Danh mục Mong muốn của giáo viên/nhân viên
  getPublicTeachersDesires(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicTeachersDesires' + '/GetSelectPaging?' + queryString);
  }  
  // Danh mục Hoạt động dạy học và hỗ trợ NKT
  getPublicTeachingAndSupport(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicTeachingAndSupport' + '/GetSelectPaging?' + queryString);
  }  
  // Danh mục Nội dung đào tạo, bồi dưỡng NKT
  getPublicTrainingAndRetraining(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicTrainingAndRetraining' + '/GetSelectPaging?' + queryString);
  }  
  AddStaffSurvey(Survey: TeacherSurvey): Observable<any> {
    if(Survey.id == 0 || Survey.id == undefined) {
        return this.http.post(this.url  + '/StaffSurveyPublic/Add', Survey, this.httpOptions);
    } 
  }
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  

  ///////////////Giáo viên///////////
  getDiploma(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicDiploma' + '/GetSelectPaging?' + queryString);
  } 
  getCaCoordinationAsfacs(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicDiploma' + '/GetSelectPaging?' + queryString);
  } 
  getPublicMajor(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicDisMajors' + '/GetSelectPaging?' + queryString);
  } 
  getPublicQualification(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicDisQualifications' + '/GetSelectPaging?' + queryString);
  }
  getPublicCaCoordinationAsfacs(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/' + 'PublicCaCoordinationAsfacs' + '/GetSelectPaging?' + queryString);
  }
  
}
